import React from "react";

export default function ReviewDetailsCard({
    isCryptoFlow,
    isCryptoToFiatFlow,
    isCrossBorder,
    isBankRecipient,
    currency,
    youSendText,
    displayAmount,
    feeText,
    recipientDetails,
    crossBorderRate,
    cbTo,
    usdReviewDetails,
    displayMemo,
    displayInvoiceName,
    displayOtherDocName,
}) {
    return (
        <div className="bg-white rounded-xl p-6 space-y-6 text-normal">
            <div className="flex justify-between">
                <span className="text-[#344054]">You send</span>
                <span className="text-[#101828] font-semibold text-base">{youSendText}</span>
            </div>

            <div className="flex justify-between">
                <span className="text-[#344054]">Transfer fee</span>
                <span className="text-[#667085] font-medium">{feeText}</span>
            </div>

            {isCrossBorder && (
                <div className="flex justify-between">
                    <span className="text-[#344054]">Recipient recieves</span>
                    <span className="text-[#101828] font-semibold">
                        {recipientDetails?.payoutCurrency}{" "}
                        {Number(Number(displayAmount) * crossBorderRate)?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}
                    </span>
                </div>
            )}

            <hr className="border-t border-[#E4E7EC]" />

            <div className="flex justify-between">
                <span className="text-[#344054] block mb-1">Send to</span>
                <div className="text-right">
                    {!!(recipientDetails?.name || isCryptoFlow) && (
                        <p className="text-[#101828] font-semibold">
                            {recipientDetails?.name || "External wallet"}
                        </p>
                    )}

                    {!isCryptoFlow &&
                        !isCryptoToFiatFlow &&
                        !isCrossBorder &&
                        !!recipientDetails?.accountNumber && (
                            <p className="text-[#667085]">{recipientDetails?.accountNumber}</p>
                        )}

                    {isCryptoFlow && (
                        <>
                            {!!recipientDetails?.accountNumber && (
                                <p className="text-[#667085] break-all">
                                    {recipientDetails?.accountNumber}
                                </p>
                            )}
                            {recipientDetails?.network && (
                                <p className="text-[#667085]">
                                    <span className="inline-block text-xs px-2 py-0.5 rounded-full bg-[#F2F3FC] text-[#383B56]">
                                        {recipientDetails.network}
                                    </span>
                                </p>
                            )}
                        </>
                    )}

                    {isCryptoToFiatFlow && (
                        <>
                            {!!recipientDetails?.bankName && (
                                <p className="text-[#667085]">{recipientDetails?.bankName}</p>
                            )}
                            {!!recipientDetails?.accountNumber && (
                                <p className="text-[#667085]">{recipientDetails?.accountNumber}</p>
                            )}
                            {!!recipientDetails?.bankCode && (
                                <p className="text-[#667085]">{recipientDetails?.bankCode}</p>
                            )}
                            {!!recipientDetails?.payoutCurrency && (
                                <p className="text-[#667085]">
                                    Payout currency: {recipientDetails?.payoutCurrency}
                                </p>
                            )}
                            {recipientDetails?.network && (
                                <p className="text-[#667085]">
                                    <span className="inline-block text-xs px-2 py-0.5 rounded-full bg-[#F2F3FC] text-[#383B56]">
                                        {recipientDetails.network}
                                    </span>
                                </p>
                            )}
                        </>
                    )}

                    {isCrossBorder && (
                        <>
                            {!!recipientDetails?.bankName && (
                                <p className="text-[#667085]">{recipientDetails?.bankName}</p>
                            )}
                            {!!(recipientDetails?.accountNumber || recipientDetails?.extra?.iban) && (
                                <p className="text-[#667085]">
                                    {recipientDetails?.accountNumber || recipientDetails?.extra?.iban}
                                </p>
                            )}
                            {recipientDetails?.extra?.iban && (
                                <p className="text-[#667085]">IBAN: {recipientDetails.extra.iban}</p>
                            )}
                            {recipientDetails?.extra?.swiftBic && (
                                <p className="text-[#667085]">
                                    SWIFT/BIC: {recipientDetails.extra.swiftBic}
                                </p>
                            )}
                            {recipientDetails?.extra?.routingNumber && (
                                <p className="text-[#667085]">
                                    Routing: {recipientDetails.extra.routingNumber}
                                </p>
                            )}
                            {recipientDetails?.extra?.bankCode && (
                                <p className="text-[#667085]">{recipientDetails.extra.bankCode}</p>
                            )}
                            {cbTo === "GBP" && recipientDetails?.extra?.sortCode && (
                                <p className="text-[#667085]">
                                    Sort code: {recipientDetails.extra.sortCode}
                                </p>
                            )}
                            {!!recipientDetails?.payoutCurrency && (
                                <p className="text-[#667085]">
                                    Payout currency: {recipientDetails?.payoutCurrency}
                                </p>
                            )}
                        </>
                    )}

                    {isBankRecipient && currency === "USD" && (
                        <>
                            {!!usdReviewDetails?.bankName && (
                                <p className="text-[#667085]">{usdReviewDetails?.bankName}</p>
                            )}
                            {!!usdReviewDetails?.ownerName && (
                                <p className="text-[#667085]">
                                    Account owner: {usdReviewDetails.ownerName}
                                </p>
                            )}

                            {usdReviewDetails?.accountType === "iban" ? (
                                <>
                                    {!!usdReviewDetails?.iban && (
                                        <p className="text-[#667085]">IBAN: {usdReviewDetails?.iban}</p>
                                    )}
                                    {!!usdReviewDetails?.bic && (
                                        <p className="text-[#667085]">
                                            SWIFT/BIC: {usdReviewDetails?.bic}
                                        </p>
                                    )}
                                    {!!usdReviewDetails?.country && (
                                        <p className="text-[#667085]">
                                            Country: {usdReviewDetails?.country}
                                        </p>
                                    )}
                                </>
                            ) : usdReviewDetails?.accountType === "international_wire" ? (
                                <>
                                    {!!usdReviewDetails?.accountNumber && (
                                        <p className="text-[#667085]">
                                            Account: {usdReviewDetails?.accountNumber}
                                        </p>
                                    )}
                                    {!!usdReviewDetails?.routingNumber && (
                                        <p className="text-[#667085]">
                                            Routing: {usdReviewDetails?.routingNumber}
                                        </p>
                                    )}
                                    {!!usdReviewDetails?.bic && (
                                        <p className="text-[#667085]">
                                            SWIFT/BIC: {usdReviewDetails?.bic}
                                        </p>
                                    )}
                                    {!!usdReviewDetails?.country && (
                                        <p className="text-[#667085]">
                                            Country: {usdReviewDetails?.country}
                                        </p>
                                    )}
                                </>
                            ) : (
                                <>
                                    {!!usdReviewDetails?.routingNumber && (
                                        <p className="text-[#667085]">
                                            Routing: {usdReviewDetails?.routingNumber}
                                        </p>
                                    )}
                                    {!!usdReviewDetails?.accountNumber && (
                                        <p className="text-[#667085]">
                                            Account: {usdReviewDetails?.accountNumber}
                                            {usdReviewDetails?.checkingOrSavings
                                                ? ` (${usdReviewDetails?.checkingOrSavings})`
                                                : ""}
                                        </p>
                                    )}
                                </>
                            )}

                            {!!usdReviewDetails?.fullAddress && (
                                <p className="text-[#667085]">{usdReviewDetails?.fullAddress}</p>
                            )}
                        </>
                    )}
                </div>
            </div>

            <hr className="border-t border-[#E4E7EC]" />

            <div className="flex justify-between">
                <span className="text-[#344054] block mb-1">Memo</span>
                <p className="text-[#667085] md:pl-80 text-end">{displayMemo || "N/A"}</p>
            </div>

            <hr className="border-t border-[#E4E7EC]" />

            <div className="flex justify-between">
                <span className="text-[#344054]">Invoice</span>
                <span className="text-[#667085]">{displayInvoiceName}</span>
            </div>
            <div className="flex justify-between">
                <span className="text-[#344054]">Supporting document</span>
                <span className="text-[#667085]">{displayOtherDocName}</span>
            </div>
        </div>
    );
}
